import { useState, useEffect, useRef, SetStateAction, Dispatch } from 'react';
import { useOnClickOutside } from './useOnClickOutside';
import { FilterFormData } from 'app/components/FilterPanel/FilterPanel';

interface TermI {
  inPortKey: string;
  inAreaCode: string;
  destinationPortKey: string;
}
export interface SearchStateI {
  term: TermI;
  visibility: {
    inPortKey: boolean;
    inAreaCode: boolean;
    destinationPortKey: boolean;
  };
}
export const useFilterComboboxState = (
  initialFormValue: FilterFormData,
): [SearchStateI, Dispatch<SetStateAction<SearchStateI>>] => {
  const [searchState, setSearchState] = useState<SearchStateI>({
    term: {
      inPortKey: '',
      inAreaCode: '',
      destinationPortKey: '',
    },
    visibility: {
      inPortKey: false,
      inAreaCode: false,
      destinationPortKey: false,
    },
  });
  const rootRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(rootRef, () => {
    setSearchState((prev) => ({
      term: {
        ...prev.term,
      },
      visibility: {
        inPortKey: false,
        inAreaCode: false,
        destinationPortKey: false,
      },
    }));
  });

  useEffect(() => {
    if (initialFormValue.selectedInPort?.name) {
      const name = initialFormValue.selectedInPort?.name;
      setSearchState((prev) => ({
        term: {
          ...prev.term,
          inPortKey: name,
        },
        visibility: {
          ...prev.visibility,
        },
      }));
    }
  }, [initialFormValue.selectedInPort]);

  useEffect(() => {
    if (initialFormValue.selectedInArea?.name) {
      const name = initialFormValue.selectedInArea.name;
      setSearchState((prev) => ({
        term: {
          ...prev.term,
          inAreaCode: name,
        },
        visibility: {
          ...prev.visibility,
        },
      }));
    }
  }, [initialFormValue.selectedInArea]);

  useEffect(() => {
    if (initialFormValue.selectedDestinationPort?.name) {
      const name = initialFormValue.selectedDestinationPort.name;
      setSearchState((prev) => ({
        term: {
          ...prev.term,
          destinationPortKey: name,
        },
        visibility: {
          ...prev.visibility,
        },
      }));
    }
  }, [initialFormValue.selectedDestinationPort]);
  return [searchState, setSearchState];
};
